import { render } from "./PremiumSkeleton.vue?vue&type=template&id=de2eb19e&scoped=true"
const script = {}

import "./PremiumSkeleton.vue?vue&type=style&index=0&id=de2eb19e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de2eb19e"]])

export default __exports__